import { Icon } from '@distribusion/owl-frontend-ui'
import cn from 'classnames'
import React, { PropsWithChildren } from 'react'

import bem from '@lib/bem'

import '@pages/Checkout/SeatSelection/NewSeats/Warning.scss'

export const Warning: React.FC<PropsWithChildren> = ({ children }) => (
  <div data-tag="new-seats-warning" className={cn(bem('new-seats', 'warning'), 'row', 'items-center')}>
    <Icon size="small" name="alert" />
    {children}
  </div>
)
